(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-loop-fix"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setupInfiniteCatalog(){
    document.querySelectorAll('[data-pc-catalog]').forEach(function(root){
      root.querySelectorAll('[data-marquee]').forEach(function(viewport){
        if(viewport.dataset.pcInfiniteFix === '1') return;
        viewport.dataset.pcInfiniteFix = '1';

        var track = viewport.querySelector('.pc-catalog-marquee__track');
        if(!track) return;

        function ensureLoopSpace(){
          var guard = 0;
          while(guard < 5){
            var total = viewport.scrollWidth;
            var maxScroll = Math.max(0, total - viewport.clientWidth);
            var resetPoint = total / 2;
            if(maxScroll >= resetPoint + 2) break;

            var groups = Array.prototype.slice.call(track.children).filter(function(node){
              return node.classList && node.classList.contains('pc-catalog-marquee__group');
            });
            if(!groups.length) break;

            groups.forEach(function(group){
              var clone = group.cloneNode(true);
              clone.setAttribute('aria-hidden','true');
              track.appendChild(clone);
            });
            guard++;
          }
        }

        ensureLoopSpace();
        window.addEventListener('resize', ensureLoopSpace, {passive:true});

        viewport.addEventListener('mouseenter', function(){
          requestAnimationFrame(function(){
            viewport.dispatchEvent(new Event('mouseleave'));
          });
        });
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', setupInfiniteCatalog, {once:true});
  }else{
    setupInfiniteCatalog();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalog-speed-boost"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boost(){
    document.querySelectorAll('[data-pc-catalog] [data-marquee]').forEach(function(viewport){
      if(viewport.dataset.pcSpeedBoost==='1') return;
      viewport.dataset.pcSpeedBoost='1';
      var paused=false;
      var resumeAt=0;
      var last=performance.now();
      var extraSpeed=45;
      function pause(){paused=true;resumeAt=Infinity}
      function resume(){paused=false;resumeAt=performance.now()+400;last=performance.now()}
      viewport.addEventListener('pointerdown',pause,{passive:true});
      viewport.addEventListener('pointerup',resume,{passive:true});
      viewport.addEventListener('pointercancel',resume,{passive:true});
      viewport.addEventListener('touchend',resume,{passive:true});
      viewport.addEventListener('touchcancel',resume,{passive:true});
      function tick(now){
        var dt=Math.min(50,now-last);last=now;
        if(!document.hidden&&!paused&&now>=resumeAt){viewport.scrollLeft+=extraSpeed*dt/1000}
        requestAnimationFrame(tick)
      }
      requestAnimationFrame(tick)
    })
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boost,{once:true}); else boost();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-button-fixed"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initReviewAction(root){
    var button=root.querySelector('[data-pc-open-review]');
    var selector=root.querySelector('[data-pc-review-product]');
    if(!button)return;

    function selectedEngine(){
      var productId=selector ? selector.value : '';
      return productId ? root.querySelector('[data-pc-review-engine="'+productId+'"]') : root.querySelector('.pc-review-engine');
    }

    function findTrigger(){
      var engine=selectedEngine(); if(!engine)return null;
      return engine.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link, button[class*="write-review"], a[class*="write-rev"]');
    }

    button.addEventListener('click',function(){
      var trigger=findTrigger();
      if(trigger){trigger.click();return;}
      var tries=0; button.disabled=true;
      var timer=setInterval(function(){
        tries++; trigger=findTrigger();
        if(trigger){clearInterval(timer);button.disabled=false;trigger.click();return;}
        if(tries>=40){clearInterval(timer);button.disabled=false;}
      },150);
    });
  }
  document.querySelectorAll('[data-pc-review-action]').forEach(initReviewAction);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-host"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCarousel(root){
    var track=root.querySelector('[data-pc-review-track]'); if(!track)return;
    var cards=Array.prototype.slice.call(track.querySelectorAll('.pc-review-card')); if(!cards.length)return;
    var prev=root.querySelector('[data-pc-review-prev]'),next=root.querySelector('[data-pc-review-next]'),index=0,timer=null,paused=false;
    var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function goTo(i){index=(i+cards.length)%cards.length;track.scrollTo({left:cards[index].offsetLeft-track.offsetLeft,behavior:reduceMotion?'auto':'smooth'});}
    function start(){if(reduceMotion||cards.length<2)return;clearInterval(timer);timer=setInterval(function(){if(!paused)goTo(index+1);},5000);}
    function pause(){paused=true;} function resume(){paused=false;start();}
    if(prev)prev.addEventListener('click',function(){pause();goTo(index-1);setTimeout(resume,2500);});
    if(next)next.addEventListener('click',function(){pause();goTo(index+1);setTimeout(resume,2500);});
    root.addEventListener('mouseenter',pause);root.addEventListener('mouseleave',resume);root.addEventListener('focusin',pause);root.addEventListener('focusout',resume);track.addEventListener('touchstart',pause,{passive:true});track.addEventListener('touchend',function(){setTimeout(resume,1200);},{passive:true});start();
  }
  document.querySelectorAll('[data-pc-review-carousel]').forEach(initCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
